import React, { useRef, useEffect } from 'react';

import { Marker, Popup } from 'react-leaflet';

import { useGeolocationContext } from '../hooks/geolocationContext';

import { MarkerPopup } from './MarkerPopup';

const getVehiclePin = (isVehicleOnline) => {
	const color = isVehicleOnline ? 'green' : 'red';

	return new L.Icon({
		iconUrl: `images/vehicle-pin-${color}.svg`,
		iconRetinaUrl: `images/vehicle-pin-${color}.svg`,
		iconAnchor: [30, 50],
		popupAnchor: [0, -35],
		iconSize: [60, 60],
		// shadowUrl: 'images/vendor/leaflet/dist/marker-shadow.png',
		// shadowSize: [29, 50],
		// shadowAnchor: [7, 60],
	})
}

export const VehicleMarker = ({ deviceVehicle }) => {
	const { selectedVehicle, handleVehicleMarkerClick } = useGeolocationContext();

	const vehicle = deviceVehicle || selectedVehicle;

	const markerRef = useRef(null);

	useEffect(() => {
		const openPopup = deviceVehicle.id === selectedVehicle?.id

		if (openPopup) markerRef.current.leafletElement.openPopup();
	}, [selectedVehicle]);

	const { latitude, longitude } = vehicle?.gpsDevice?.deviceStatus;
	const position = [latitude, longitude];

	const isDeviceOnline = vehicle.gpsDevice.deviceStatus.isDeviceCommunicating;

	return (
		<Marker
			ref={markerRef}
			position={position}
			icon={getVehiclePin(isDeviceOnline)}
			onClick={() => handleVehicleMarkerClick(vehicle)}
		>
			<Popup>
				<MarkerPopup vehicle={vehicle} />
			</Popup>
		</Marker>
	)
}
